'use client'
import axiomClient from '@/lib/axiom/axiom'
import { Logger, AxiomJSTransport } from '@axiomhq/logging'
import { createUseLogger } from '@axiomhq/react'
import { nextJsFormatters } from '@axiomhq/nextjs/client'

// Client-side logger (browser). Ingests directly to Axiom. `useLogger()` returns a Logger
// that supports `.with({...})`, `.info/warn/error()` and `.flush()`, and auto-flushes on
// navigation. (Web Vitals deliberately not wired up.)
export const logger = new Logger({
  transports: [
    new AxiomJSTransport({ axiom: axiomClient, dataset: process.env.NEXT_PUBLIC_AXIOM_DATASET ?? '' }),
  ],
  formatters: nextJsFormatters,
})

export const useLogger = createUseLogger(logger)
